import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { AdvanceFilter, StoreFilterParams } from '../../common/types'
import { defaultPageParams } from '../constants'

const defaultParams: any = []

export const useAggregateReportFilterStore =
  create<AggregateReportFilterStore>()(
    persist(
      (set) => ({
        pageParams: defaultPageParams,
        advanceFilter: {
          filterParams: defaultParams,
          isDetailed: true,
        },
        selectedRows: [],

        setAdvanceFilter: (data) => set(() => ({ advanceFilter: data })),
        clearSelectedRows: () => set({ selectedRows: [] }),
        setPageParams: (data) => set(() => ({ pageParams: data })),
        clearAdvanceFilter: () =>
          set(() => ({
            advanceFilter: {
              filterParams: defaultParams?.map((item: any) => ({
                ...item,
                isChecked: false,
              })),
              isDetailed: true,
            },
          })),
        setSelectedRows: (data) => set(() => ({ selectedRows: data })),
        clearAggregateReportFilter: (key) =>
          set((state) => ({
            pageParams: key
              ? { ...defaultPageParams, search: state?.pageParams?.search }
              : defaultPageParams,
          })),
        // resetStore: () =>
        //   set(() => ({
        //     pageParams: defaultPageParams,
        //     advanceFilter: {
        //       filterParams: defaultParams,
        //       isDetailed: true,
        //     },
        //     selectedRows: [],
        //     search: '',
        //   })),
      }),
      { name: 'fit__aggregate_report_store' }
    )
  )

type AggregateReportFilterStore = {
  pageParams: StoreFilterParams
  selectedRows?: (number | string)[]
  advanceFilter: AdvanceFilter
  setSelectedRows: (data: (number | string)[]) => void
  setPageParams: (data: StoreFilterParams) => void
  setAdvanceFilter: (data: AdvanceFilter) => void
  clearAggregateReportFilter: (key?: string) => void
  clearSelectedRows: () => void
  clearAdvanceFilter: () => void
  // resetStore: () => void
}
